import { RigidBody } from '@react-three/rapier';

export const MapLimits = () => {
    // Terrain size is 300x300.
    // Limits should be at +/- 150.

    return (
        <group>
            {/* North Wall (-Z) */}
            <RigidBody type="fixed" colliders="cuboid" position={[0, 10, -300]}>
                <mesh visible={false}>
                    <boxGeometry args={[600, 50, 1]} />
                    <meshBasicMaterial color="red" wireframe />
                </mesh>
            </RigidBody>

            {/* South Wall (+Z) */}
            <RigidBody type="fixed" colliders="cuboid" position={[0, 10, 300]}>
                <mesh visible={false}>
                    <boxGeometry args={[600, 50, 1]} />
                    <meshBasicMaterial color="red" wireframe />
                </mesh>
            </RigidBody>

            {/* East Wall (+X) */}
            <RigidBody type="fixed" colliders="cuboid" position={[300, 10, 0]}>
                <mesh visible={false}>
                    <boxGeometry args={[1, 50, 600]} />
                    <meshBasicMaterial color="red" wireframe />
                </mesh>
            </RigidBody>

            {/* West Wall (-X) */}
            <RigidBody type="fixed" colliders="cuboid" position={[-300, 10, 0]}>
                <mesh visible={false}>
                    <boxGeometry args={[1, 50, 600]} />
                    <meshBasicMaterial color="red" wireframe />
                </mesh>
            </RigidBody>
        </group>
    );
};
